// src/components/LoadingSpinner.js
import React from "react";

const LoadingSpinner = ({ text }) => {
  return (
    <div style={{ 
      display: "flex", 
      flexDirection: "column",
      justifyContent: "center", 
      alignItems: "center", 
      height: "200px",
      minHeight: 120,
      width: "100%"
    }}>
      <svg width="64" height="64" viewBox="0 0 50 50">
        <defs>
          <linearGradient id="spinner-gradient" x1="0%" y1="0%" x2="100%" y2="100%">
            <stop offset="0%" stopColor="#4a90e2" />
            <stop offset="100%" stopColor="#00c49f" />
          </linearGradient>
        </defs>
        <circle
          cx="25"
          cy="25"
          r="20"
          fill="none"
          stroke="#f3f3f3"
          strokeWidth="6"
        />
        <circle
          cx="25"
          cy="25"
          r="20"
          fill="none"
          stroke="url(#spinner-gradient)"
          strokeWidth="6"
          strokeLinecap="round"
          strokeDasharray="90 60"
          strokeDashoffset="0"
        >
          <animateTransform
            attributeName="transform"
            type="rotate"
            from="0 25 25"
            to="360 25 25"
            dur="1s"
            repeatCount="indefinite"
          />
        </circle>
      </svg>
      {text && (
        <div style={{ marginTop: 18, fontSize: 18, color: '#4a90e2', fontWeight: 500, letterSpacing: 1 }}>{text}</div>
      )}
    </div>
  );
};

export default LoadingSpinner;